import defaultHeaderImg from '../../assets/images/default-header.png';
import Body from '../../components/GameTicket/GameTicket';
import { ActionType } from '../../enums';

import {
  TXTCLI_Close,
  TXTWCL_An_error_occurred_with_your_ac_ELL
} from './NotificationError.messages.json';

const i18nTags = {
  title: { tag: TXTWCL_An_error_occurred_with_your_ac_ELL },
  close: { tag: TXTCLI_Close }
};

export default {
  front: {
    view: Body,
    viewConfig: {
      title: i18nTags.title,
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      displayAttributes: [],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: i18nTags.close
        }
      ]
    }
  }
};
